import React from "react"

import styled from "styled-components"

import { colors } from "@izettle/otto"
import { EmptyState as ZettleEmptyState, EmptyStateImageSize } from "@izettle/react"
import { useLocalization } from "@izettle/tenko-react"

import { Container, Page, View } from "@/core/components/shared"

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  * {
    text-align: center;
    color: ${colors.text.secondary};
  }
`

export const EmptyState = () => {
  const { text } = useLocalization()

  return (
    <Page>
      <View>
        <Container>
          <Wrapper>
            <ZettleEmptyState.Image
              size={EmptyStateImageSize.Large}
              headline={text("SIGNUP_404_TITLE")}
              subtitle={text("SIGNUP_404_DESC")}
              isDefaultImage
            />
          </Wrapper>
        </Container>
      </View>
    </Page>
  )
}
